import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { RoleService } from './role.service';

@Directive({
    selector: '[pvRole]'
})
export class PvRoleDirective implements OnChanges {

    @Input()
    pvRole: string;

    @Input()
    pvRoleOrg: string;

    private _hasView = false;

    constructor(
        private _templateRef: TemplateRef<any>,
        private _viewContainer: ViewContainerRef,
        private _roleService: RoleService,
    ) { }

    ngOnChanges() {
        this._updateView();
    }

    private _updateView() {
        const shouldRender = this.pvRole === 'write' && this._roleService.canWrite(this.pvRoleOrg);

        if (shouldRender && !this._hasView) {
            this._viewContainer.createEmbeddedView(this._templateRef);
            this._hasView = true;
        } else if (!shouldRender && this._hasView) {
            this._viewContainer.clear();
            this._hasView = false;
        }
    }
}
